import React, { useEffect } from "react";
import "./Panels.css";
import admin from "../../Assets/vectors/Icons/admin.png";
import student from "../../Assets/vectors/Icons/student.svg";
import teacher from "../../Assets/vectors/Icons/teacher.svg";
import directors from "../../Assets/vectors/Icons/directorpng.png";
import accountant from "../../Assets/vectors/Icons/accountant.svg";

export default function Panels() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
  return (
    <div className="mainContainer panels">
      <div className="textCenter mb2">
        <h1>Portals</h1>
        <b style={{ fontSize: "18px" }}>Select Your Panel To Continue.</b>
      </div>
      <div className="grid container">
        <a
          className="card"
          href="https://admin.madanischoolandcollege.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={admin} alt="" />
          <h2>Admin</h2>
        </a>
        <a
          className="card"
          href="https://admin.madanischoolandcollege.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={accountant} alt="" />
          <h2>Accountant</h2>
        </a>
        <a
          className="card"
          href="https://director.madanischoolandcollege.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={directors} alt="" />
          <h2>Director</h2>
        </a>
        <a
          className="card"
          href="https://student.madanischoolandcollege.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={student} alt="" />
          <h2>Student</h2>
        </a>
        <a
          className="card"
          href="https://teacher.madanischoolandcollege.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={teacher} alt="" />
          <h2>Teacher</h2>
        </a>
      </div>
    </div>
  );
}
